var map = {
	"./angular1.png": 7617,
	"./couch1.png": 2683,
	"./golang1.png": 3968,
	"./heading_img.png": 6054,
	"./lara1.png": 7918,
	"./messenger.png": 8965,
	"./php1.png": 7194,
	"./post1.png": 4938,
	"./react1.png": 6359,
	"./road_map.png": 1017,
	"./skype.png": 6422,
	"./sql1.png": 2053,
	"./tech_1.png": 13,
	"./tech_10.png": 7015,
	"./tech_11.png": 8512,
	"./tech_2.png": 271,
	"./tech_3.png": 4165,
	"./tech_4.png": 1028,
	"./tech_5.png": 3811,
	"./tech_6.png": 2460,
	"./tech_7.png": 9351,
	"./tech_8.png": 8834,
	"./tech_9.png": 7332,
	"./whatsapp.png": 3949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7451;